var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert",
    clipPath: "url(#clip0_1910_10109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3201 10.36L13.6401 0.680001C13.2051 0.245215 12.6152 0.000976562 12.0001 0.000976562C11.3851 0.000976562 10.7952 0.245215 10.3601 0.680001L0.680123 10.36C0.245337 10.795 0.00109863 11.3849 0.00109863 12C0.00109863 12.6151 0.245337 13.205 0.680123 13.64L10.3601 23.32C10.7952 23.7548 11.3851 23.999 12.0001 23.999C12.6152 23.999 13.2051 23.7548 13.6401 23.32L23.3201 13.64C23.7549 13.205 23.9991 12.6151 23.9991 12C23.9991 11.3849 23.7549 10.795 23.3201 10.36ZM22.2535 12.5867L12.5868 22.2533C12.4299 22.4064 12.2194 22.4921 12.0001 22.4921C11.7809 22.4921 11.5704 22.4064 11.4135 22.2533L1.74679 12.5867C1.66601 12.5118 1.60157 12.421 1.5575 12.3201C1.51343 12.2191 1.49069 12.1102 1.49069 12C1.49069 11.8899 1.51343 11.7809 1.5575 11.6799C1.60157 11.579 1.66601 11.4882 1.74679 11.4133L11.4135 1.74667C11.4883 1.66589 11.5791 1.60145 11.6801 1.55738C11.781 1.51331 11.89 1.49056 12.0001 1.49056C12.1103 1.49056 12.2192 1.51331 12.3202 1.55738C12.4211 1.60145 12.5119 1.66589 12.5868 1.74667L22.2535 11.4133C22.3325 11.4892 22.3954 11.5803 22.4384 11.6811C22.4813 11.782 22.5035 11.8904 22.5035 12C22.5035 12.1096 22.4813 12.218 22.4384 12.3189C22.3954 12.4197 22.3325 12.5108 22.2535 12.5867ZM13.2267 15.4533H10.7867V17.8933H13.2267V15.4533ZM11.6 13.0132L10.7867 9.25324V5.69324H13.2267V9.25324L12.4134 13.0132H11.6Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1910_10109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWhite);
export default __webpack_public_path__ + "static/media/alertWhite.264a1ad182d3c951086414b1f2b9ef13.svg";
export { ForwardRef as ReactComponent };